// extracted by mini-css-extract-plugin
module.exports = {"more_images":"ItemTabs_more_images__2rGo-","image":"ItemTabs_image__3a-XQ"};